import React, { useEffect, useMemo, useState } from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import ButtonWrapper from '../ButtonWrapper';

const WebformActions = (props) => {
  const { t } = useTranslation();
  const {
    entity, pages, onPreviousPage, currentPage, handleSubmit, isSubmitting, webformHasWizardWithButtons,
  } = props;
  const wrapperClassNames = c('WebformComponent__submit', entity.getIn(['#attributes', 'class', 0], ''));
  const elementClassNames = c(entity.getIn(['#submit__attributes', 'class'], Immutable.List()).toJS().join(' '), { loading: isSubmitting });
  const [autoSubmit, enableAutosubmit] = useState(false);

  if (webformHasWizardWithButtons) {
    return null;
  }

  const collectInitialValuesFlat = (entity) => {
    let output = new Immutable.List();
    const mappedEntity = Immutable.fromJS(entity);
    output = output.push(mappedEntity.get('#webform_key'));

    // Collect child items.
    let children = Immutable.fromJS(entity);
    children.keySeq().forEach((k) => {
      if (k.indexOf('#') === 0) {
        children = children.delete(k);
      }
    });

    children.entrySeq().forEach(([key, e]) => {
      const c = collectInitialValuesFlat(e);
      output = output.merge(c);
    });

    return output;
  };
  const onNextButton = () => {
    const { setFieldTouched, validateForm, entities, onNextPage, handleSubmit } = props;

    // Determine all children in this page.
    const fieldsInThisPage = collectInitialValuesFlat(entities);

    validateForm()
      .then((validation) => {
        let validated = true;

        Immutable.fromJS(validation).keySeq().forEach((invalidField) => {
          // Check if this field is contained by this page.
          if (fieldsInThisPage.contains(invalidField)) {
            validated = false;
            setFieldTouched(invalidField);
          }
        });

        if (validated) {
          if (currentPage !== pages.last()) {
            onNextPage();
          } else {
            handleSubmit();
          }
        }
      });
  };
  // Check if we should use the page labels or the submit actions  per page labels.
  const hidePreviousLabel = entity.get('#wizard_prev_hide', false);
  const previousLabel = entity.get('#wizard_prev__label', t('webform.actions.wizard_prev_label'));

  const hideNextLabel = entity.get('#wizard_next_hide', false);
  const nextLabel = useMemo(() => {
    // Check if we should use the page labels or the submit actions per page.
    if (currentPage === pages.last()) {
      return entity.get('#submit__label', t('webform.actions.submit_label'));
    }

    return entity.get('#wizard_next__label', t('webform.actions.wizard_next_label'));
  }, [currentPage, pages, entity, t]);

  let onClickPrevious = () => { };
  let onClickNext = handleSubmit;
  if (pages.size !== 0) {
    onClickPrevious = onPreviousPage;
    onClickNext = onNextButton;
  }

  // If we hide the submit button when using Wizard pages, auto-submit on the last page.
  useEffect(() => {
    if (entity.get('#submit_hide', false) && currentPage === pages.last() && !isSubmitting) {
      enableAutosubmit(true);
    }
  }, [entity, currentPage, pages, isSubmitting]);

  // Use a second effect to prevent multiple submissions, since Formik re-renders often.
  useEffect(() => {
    if (autoSubmit) {
      handleSubmit(false);
    }
  }, [autoSubmit]);

  return (
    <div className={wrapperClassNames}>
      {
        (!hidePreviousLabel && currentPage !== pages.first()) && (
          <ButtonWrapper className={c(elementClassNames, 'WebformComponent__submit__prev')} type="button" onClick={onClickPrevious} disabled={isSubmitting}>
            {previousLabel}
          </ButtonWrapper>
        )
      }
      {
        (!hideNextLabel || currentPage === pages.last()) && (
          <ButtonWrapper iconName="arrow_forward" className={c(elementClassNames, 'WebformComponent__submit__next')} type="button" onClick={onClickNext} disabled={isSubmitting}>
            {nextLabel}
          </ButtonWrapper>
        )
      }
    </div>
  );
};

export default WebformActions;
